'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var parts = ['container', 'value', 'label'];
var baseStyle = {
  container: {
    layerStyle: 'card',
    alignItems: 'center',
    flex: '1 1 0',
    py: 2,
    px: 3
  },
  value: {
    fontSize: '2xl',
    fontWeight: 'semibold'
  },
  label: {
    fontSize: 'sm',
    fontWeight: 'normal',
    lineHeight: 'none'
  }
};
var StatisticsCard = {
  baseStyle: baseStyle,
  parts: parts
};
exports["default"] = StatisticsCard;